import { Role } from "../../types/role";

const LIun: Role = {
  primary: [
    "Ballannahme",
    "Deckung",
    "Dribbling",
    "Passen",
    "Tackling",
    "Antizipation",
    "Entscheidungen",
    "Konzentration",
    "Nervenstaerke",
    "Stellungsspiel",
    "Teamwork",
    "Uebersicht",
    "Schnelligkeit",
  ],
  secondary: [
    "Dribbling",
    "Kopfball",
    "Technik",
    "Flair",
    "Mut",
    "Ausdauer",
    "Balance",
    "Beweglichkeit",
    "Kraft",
    "Sprunghoehe",
  ],
  physis: "abwehr",
};
const LIan: Role = {
  primary: [
    "Ballannahme",
    "Deckung",
    "Dribbling",
    "Passen",
    "Tackling",
    "Antizipation",
    "Entscheidungen",
    "Flair",
    "Konzentration",
    "Nervenstaerke",
    "Stellungsspiel",
    "Teamwork",
    "Uebersicht",
    "Schnelligkeit",
  ],
  secondary: [
    "Kopfball",
    "Technik",
    "Weitschuesse",
    "Mut",
    "Antritt",
    "Ausdauer",
    "Balance",
    "Beweglichkeit",
    "Kraft",
    "Sprunghoehe",
  ],
  physis: "abwehr",
};
export const LI = {
  LIun,
  LIan,
};
